import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, HostBinding, input, output } from '@angular/core';
import { OrderEntry, ProductType } from '@boels/models';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { OrderEntryProductQuantityComponent } from '../order-entry-product-quantity/order-entry-product-quantity.component';
import { OrderEntryAccessoryLabelComponent } from '../order-entry-accessory-label/order-entry-accessory-label.component';
import { OrderEntryDeleteComponent } from '../order-entry-delete/order-entry-delete.component';
import { ProductPriceComponent } from '../product-price/product-price.component';
import { ProductThumbnailComponent } from '../product-thumbnail/product-thumbnail.component';
import { ProductTitleComponent } from '../product-title/product-title.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgClass } from '@angular/common';
import { ProductIdentifierComponent } from '../product-identifier/product-identifier.component';
import { QuantityComponent } from '../quantity/quantity.component';
import { SafeHtmlPipe } from '@boels/helpers';

@Component({
  selector: 'boels-order-entry-item',
  templateUrl: './order-entry-item.component.html',
  styleUrls: ['./order-entry-item.component.scss'],
  imports: [
    NgClass,
    OrderEntryProductQuantityComponent,
    OrderEntryDeleteComponent,
    OrderEntryAccessoryLabelComponent,
    ProductThumbnailComponent,
    ProductTitleComponent,
    ProductPriceComponent,
    FaIconComponent,
    ProductIdentifierComponent,
    QuantityComponent,
    SafeHtmlPipe,
  ],
  animations: [
    trigger('collapse', [
      state(
        'collapsed',
        style({ height: '0px', overflow: 'hidden', opacity: 0 }),
      ),
      state('expanded', style({ height: '*', opacity: 1 })),
      transition('collapsed <=> expanded', animate('300ms ease-in-out')),
    ]),
  ],
})
export class OrderEntryItemComponent {
  orderEntry = input.required<OrderEntry>();
  variant = input.required<'edit' | 'readonly'>();
  type = input.required<ProductType>();
  autoFocusTarget = input<string | undefined>(undefined);

  mainQuantityChanged = output<number>();
  entryEditRequested = output<OrderEntry>();
  deleteOrderEntry = output<number>();

  isCollapsed = true;

  @HostBinding('class') get hostClasses() {
    return `${this.type()} ${this.variant()}`.trim();
  }

  canCollapse() {
    return (
      this.variant() === 'edit' &&
      this.type() === 'accessory' &&
      this.orderEntry().product?.description
    );
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  protected readonly faChevronUp = faChevronUp;
  protected readonly faChevronDown = faChevronDown;
}
